import { render, staticRenderFns } from "./UgiMap.vue?vue&type=template&id=58326e82&scoped=true&"
import script from "./UgiMap.vue?vue&type=script&lang=js&"
export * from "./UgiMap.vue?vue&type=script&lang=js&"
import style0 from "./UgiMap.vue?vue&type=style&index=0&id=58326e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58326e82",
  null
  
)

export default component.exports